import * as tslib_1 from "tslib";
import { SortIndicatorStyle_$type } from "./SortIndicatorStyle";
import { IgrDefinitionBase } from "./igr-definition-base";
import { brushToString, stringToBrush, ensureEnum } from "igniteui-react-core";
/**
 * Represents a base class used to configure the appearance of the column header cells.
*/
var IgrHeader = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrHeader, _super);
    function IgrHeader(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(IgrHeader.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrHeader.prototype, "sortIndicatorColor", {
        /**
         * Gets or sets the color to use for the sort indicator icon
        */
        get: function () {
            return brushToString(this.i.fb);
        },
        set: function (v) {
            this.i.fb = stringToBrush(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrHeader.prototype, "actualSortIndicatorColor", {
        /**
         * Gets the actual background color that is used for the cells when they are selected
        */
        get: function () {
            return brushToString(this.i.e9);
        },
        set: function (v) {
            this.i.e9 = stringToBrush(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrHeader.prototype, "sortIndicatorStyle", {
        get: function () {
            return this.i.eo;
        },
        set: function (v) {
            this.i.eo = ensureEnum(SortIndicatorStyle_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrHeader.prototype, "actualSortIndicatorStyle", {
        get: function () {
            return this.i.en;
        },
        set: function (v) {
            this.i.en = ensureEnum(SortIndicatorStyle_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrHeader.prototype, "paddingLeft", {
        /**
         * Gets or sets the amount of left padding to use for the cell content.
        */
        get: function () {
            return this.i.eu;
        },
        set: function (v) {
            this.i.eu = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrHeader.prototype, "paddingTop", {
        /**
         * Gets or sets the amount of top padding to use for the cell content.
        */
        get: function () {
            return this.i.ew;
        },
        set: function (v) {
            this.i.ew = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrHeader.prototype, "paddingRight", {
        /**
         * Gets or sets the amount of right padding to use for the cell content.
        */
        get: function () {
            return this.i.ev;
        },
        set: function (v) {
            this.i.ev = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrHeader.prototype, "paddingBottom", {
        /**
         * Gets or sets the amount of bottom padding to use for the cell content.
        */
        get: function () {
            return this.i.et;
        },
        set: function (v) {
            this.i.et = +v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrHeader;
}(IgrDefinitionBase));
export { IgrHeader };
//# sourceMappingURL=igr-header.js.map
